import script from "./device-parameter.vue?vue&type=script&setup=true&lang=js"
export * from "./device-parameter.vue?vue&type=script&setup=true&lang=js"

import "./device-parameter.vue?vue&type=style&index=0&id=b6f1f61e&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6f1f61e"]])

export default __exports__